import { ROUTER_PATH, ROUTER_TITLES } from '@/router/constants';
import TermsPage from '@/pages/policy/TermsPage';
import Terms from '@/pages/policy/terms/Terms';
import PrivacyPage from '@/pages/policy/PrivacyPage';
import Privacy from '@/pages/policy/privacy/Privacy';

export const TermsRouter = {
	element: <TermsPage />,
	title: ROUTER_TITLES.POLICY.TERMS,
	children: [
		{
			path: ROUTER_PATH.POLICY.TERMS,
			element: <Terms />,
			title: ROUTER_TITLES.POLICY.TERMS
		}
	]
};

export const PrivacyRouter = {
	element: <PrivacyPage />,
	title: ROUTER_TITLES.POLICY.PRIVACY,
	children: [
		{
			path: ROUTER_PATH.POLICY.PRIVACY,
			element: <Privacy />,
			title: ROUTER_TITLES.POLICY.PRIVACY
		}
	]
};
